import axios from 'axios'

export const state = {
}

export const getters = {
}

export const mutations = {
}

export const actions = {
  resolveDashboardUser({ commit }, id) {
    return axios.get(`/dashboard/user/${id}`)
  },
  resolveDashboardMine({ commit }) {
    return axios.get(`/dashboard/user`)
  },
}
